import { Error, Success } from "@/_service/notification/notification";
import { sendAssigneeOtp, verifySentAssigneeOtp } from "@/_service/share/share";
import { useEffect } from "react";
import OtpForm from "../auth/OtpForm";

export default function VerifyAssigneeOtp({ assigneeData, onVerifyOtp }) {

    useEffect(()=>{
        handleResendOtp();
    }, []);

    const handleResendOtp = () => {
        sendAssigneeOtp(assigneeData.assigneeUserName, null, assigneeData.assigneeUserId, assigneeData.categoryId);
    }

    const handleVerifyOtp = async (e, otp) => {
        const response = await verifySentAssigneeOtp(otp, assigneeData.assigneeUserId);
        if (response?.status === 200) {
            Success("Assigne OTP Verified Succfully")
            onVerifyOtp(true);
        } else {
            Error(response?.data?.message);
            onVerifyOtp(false);
        }
    }

    return (
        <OtpForm onResendOtp={handleResendOtp} onSubmitOtp={handleVerifyOtp} />
    )
}